import { TProfileEdgeCrease } from './t-profile-edge-crease';
import { EProfilePaintSide } from './e-profile-paint-side';
import { ProfileV1Line } from './profile-v1-line';
import { parseEdgeCrease } from './profile-utils';

export interface ProfileV1Data {
    lines: ProfileV1Line[];
    edgeCreaseSizeMM: number;
    creaseLeft: TProfileEdgeCrease;
    creaseRight: TProfileEdgeCrease;
    paintSide: EProfilePaintSide;
}

export function profileLoadV1(profile: ProfileV1Data, profileData: string): void {
    if (!profileData) {
        return;
    }

    const data = profileData.split('%');
    profile.paintSide = parseInt(data[1], 10) || EProfilePaintSide.noPaint;
    profile.creaseLeft = parseEdgeCrease(data[4]) || profile.creaseLeft;
    profile.edgeCreaseSizeMM = parseInt(data[5], 10) || profile.edgeCreaseSizeMM;
    profile.creaseRight = parseEdgeCrease(data[6]) || profile.creaseRight;

    const parsedLines = data[8] && data[8].split('|') || [];
    const reg = /1;(\d+);(\d);(\d+);(\d+);0;0/;

    parsedLines.forEach(lineData => {
        const parts = reg.exec(lineData);
        if (parts) {
            const angle = parseInt(parts[1], 10);
            const direction = 2 * parseInt(parts[2], 10) - 1;

            profile.lines.push({
                length: parseInt(parts[3], 10),
                length2: parseInt(parts[4], 10),
                alpha: angle * direction,
                direction: direction,
            });
        }
    });
}
